'use client';
import GameContext from '~/client/components/Game/context/Game/GameContext';
import useGameContextProvider from './useGameContextProvider';

const GameContextProvider: FC = ({ children }) => {
  const { value } = useGameContextProvider();
  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
};

export default GameContextProvider;
